import { Card, Divider } from 'antd';
import React, { useEffect, useState } from 'react';
import logo from '../../assets/gabaritlogo.png'
import { useParams } from 'react-router-dom';
import axios from 'axios';

function SaleCheck({ order }) {

    return (
        <Card style={{ height: '100%', backgroundColor: '#f5f5f5' }} title="Xarid cheki" >

            <div style={{ width: '76mm', overflow: 'auto', backgroundColor: '#fff', padding: '5mm', border: '.5px solid silver', borderRadius: '5px' }}>
                <div className="logo" style={{ textAlign: 'center', display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <img src={logo} style={{ width: '20mm' }} alt="logo" />
                    <h3>GABARIT AVTO MARKET</h3>
                </div>
                <hr />
                <h5>GABARIT AVTO MATKET MCHJ</h5>
                <h5>Samarqand shahri. Chilonzor tuman</h5>
                <h5>Telefon: +998933333333</h5>
                <hr />
                <h3 style={{ textAlign: 'center' }}>Buyurtma raqami: {order.id}</h3>
                <h4 style={{ textAlign: 'center' }}>Sotuvchi: Xamidov Bobur</h4>
                <Divider />

                <div>
                    <table style={{ width: '100%' }}>
                        <thead style={{ fontSize: '10px' }}>
                            <tr>
                                <td style={{ fontWeight: 'bold' }}>Maxsulot</td>
                                <td style={{ fontWeight: 'bold' }}>Soni</td>
                                <td style={{ fontWeight: 'bold' }}>Narxi</td>
                                <td style={{ fontWeight: 'bold' }}>Jami</td>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: '10px' }}>
                            {order.items?.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.name}</td>
                                    <td>{item.count}</td>
                                    <td>{item.price}</td>
                                    <td>{item.summa}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <Divider />
                <div style={{ fontSize: '12px' }}>
                    <p><b>Buyurtma chegirma:</b> {order.discount}</p>
                <p><b>Buyurtma yetkazib berish:</b> {order.deliversumm}</p>
                <p><b>Buyurtma jami summa:</b> {Number(order.items?.reduce((a, b) => a + Number(b.summa), 0)) + Number(order.deliversumm) - Number(order.discount)} </p>
                </div>


            </div>

        </Card>
    );
}

export default SaleCheck;